<template>
  <div class="tixing">
    <!-- 检前提醒 -->
    <div>
      <span class="title"> 已使用检前提醒：</span>
      <div class="cont" v-html="text"></div>
    </div>
    <div class="text-cont">
      <span class="title"> 修改检前提醒: </span>
      <div class="text">
        <i-input class="textarea" v-model.trim="areaText" type="textarea" :autosize="{ minRows: 11, maxRows: 11 }" placeholder="请输入..."></i-input>
      </div>
    </div>
    <Button class="title-btn fourSize" type="success" ghost @click="postAreaText">保存</Button>

    <div>
      <span class="title"> 已使用温馨提示：</span>
      <div class="cont" v-html="tishiText"></div>
      <!--  v-html="text" -->
    </div>
    <div class="text-cont">
      <span class="title"> 修改温馨提示: </span>
      <div class="text">
        <i-input class="textarea" v-model.trim="areaTishiText" type="textarea" :autosize="{ minRows: 11, maxRows: 11 }" placeholder="请输入..."></i-input>
      </div>
    </div>
    <Button class="title-btn fourSize" type="success" ghost @click="postTishiAreaText">保存</Button>

    <div>
      <span class="title"> 已使用小喇叭提示：</span>
      <div class="cont" v-html="speakersMessage"></div>
      <!--  v-html="text" -->
    </div>
    <div class="text-cont">
      <span class="title"> 修改小喇叭提示: </span>
      <div class="text">
        <i-input class="textarea" v-model.trim="areaSpeakersMessage" type="textarea" :autosize="{ minRows: 11, maxRows: 11 }" placeholder="请输入..."></i-input>
      </div>
    </div>
    <Button class="title-btn fourSize" type="success" ghost @click="postSpeakersMessage">保存</Button>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import { loadavg } from "os";
import {
  setRemindMessage,
  selectRemindMessage,
  selectNoticeMessage,
  setNoticeMessage,
  setSmallSpeakersQuestionMessage,
  selectSmallSpeakersQuestionMessage,
} from "../servers/api";
export default {
  name: "tixing",
  data() {
    return {
      areaText: "",
      text: "",
      speakersMessage: "",
      areaSpeakersMessage: "",
      tishiText: "",
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      areaTishiText: "",
    };
  },
  methods: {
    selectNoticeMessage() {
      //获取提醒
      this.isiconfontshow = true;
      selectNoticeMessage({}).then((res) => {
        if (res.data.code == 1) {
          // this.tishiText =
          this.isiconfontshow = false;
          if (
            res.data.data &&
            res.data.data[0] &&
            res.data.data[0].remindMessage
          ) {
            this.tishiText = res.data.data[0].remindMessage || "";
          } else {
            this.tishiText = "";
          }
        }
      });
    },
    postTishiAreaText() {
      //设置
      this.isiconfontshow = true;
      let a = "";
      a = this.areaTishiText
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\s/g, "&nbsp;");

      let params = {
        message: a,
      };
      setNoticeMessage(params).then((res) => {
        if (res.data.code == 1) {
          this.selectNoticeMessage();
          this.areaTishiText = "";
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    postAreaText() {
      //设置
      this.isiconfontshow = true;
      let a = "";
      a = this.areaText
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\s/g, "&nbsp;");

      let params = {
        message: a,
      };
      setRemindMessage(params).then((res) => {
        if (res.data.code == 1) {
          this.selectRemindMessage();
          this.areaText = "";
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    postSpeakersMessage() {
      //小喇叭
      this.isiconfontshow = true;
      let a = "";
      a = this.areaSpeakersMessage
        .replace(/\r\n/g, "<br/>")
        .replace(/\n/g, "<br/>")
        .replace(/\s/g, "&nbsp;");

      let params = {
        message: a,
      };
      setSmallSpeakersQuestionMessage(params).then((res) => {
        if (res.data.code == 1) {
          this.selectSmallSpeakersQuestionMessage();
          this.areaSpeakersMessage = "";
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    selectRemindMessage() {
      //查询
      this.isiconfontshow = true;
      selectRemindMessage({}).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          if (
            res.data.data &&
            res.data.data[0] &&
            res.data.data[0].remindMessage
          ) {
            this.text = res.data.data[0].remindMessage || "";
          } else {
            this.text = "";
          }
        }
      });
    },
    selectSmallSpeakersQuestionMessage() {
      //查询
      this.isiconfontshow = true;
      selectSmallSpeakersQuestionMessage({}).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          if (
            res.data.data &&
            res.data.data[0] &&
            res.data.data[0].remindMessage
          ) {
            this.speakersMessage = res.data.data[0].remindMessage || "";
          } else {
            this.speakersMessage = "";
          }
        }
      });
    },
  },
  created() {
    this.selectRemindMessage();
    this.selectNoticeMessage();
    this.selectSmallSpeakersQuestionMessage();
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.tixing {
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  font-size: 13px;
  overflow-y: visible;
  .cont {
    word-wrap: break-word;
    line-height: 25px;
    width: calc(100% - 100px);
    padding: 15px;
    margin: 15px;
    margin-left: 40px;
    margin-right: 40px;
    border: 1px dashed #53cac3;
    border-radius: 10px;
    overflow: hidden;
    max-height: 270px;
    overflow-y: visible;
  }
  .text-cont {
    .text {
      padding: 15px;
    }
  }
  .title {
    font-size: 16px;
  }
}

.ivu-input-wrapper /deep/ .ivu-input {
  border-radius: 10px;
}

.title-btn {
  float: right;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/yuyue/tixing.vue